import { DateTime } from 'luxon';
import { filterNil } from 'ngxtension/filter-nil';
import { map, merge, tap } from 'rxjs';

import { AbstractControl } from '@angular/forms';
import { DateUtility } from '@jms/model';
import Decimal from 'decimal.js';

export class TimesConstraintUtil {

    public static timesConstraint(startControl: AbstractControl<DateTime | Date | string>, endControl: AbstractControl<DateTime | Date | string>, options: { duration?: number, timezone?: string }) {

        const duration = options?.duration || 60;
        const timezone = options?.timezone;

        const start$ = startControl.valueChanges.pipe(
            filterNil(),
            map((startDate: DateTime | Date | string) => {
                return {
                    startDate: DateUtility.getDateTime(startDate, timezone),
                    endDate: DateUtility.getDateTime(endControl.value, timezone)
                }
            }),
            tap(({ startDate, endDate }) => {
                if (startDate >= endDate) {
                    endControl.setValue(startDate.plus({ minutes: duration }), { onlySelf: true });
                }
            })
        )

        // const end$ = endControl.valueChanges.pipe(
        //     filterNil(),
        //     map((endDate: DateTime | Date | string) => {
        //         return {
        //             startDate: DateUtility.getDateTime(startControl.value, timezone),
        //             endDate: DateUtility.getDateTime(endDate, timezone)
        //         }
        //     }),
        //     tap(({ startDate, endDate }) => {
        //         if (startDate > endDate) {
        //             startControl.setValue(endDate, { onlySelf: true });
        //         }
        //     })
        // )


        return merge(start$);

    }

    public static calculateStartEndDate(originDate: DateTime | Date | string, startDate: DateTime | Date | string, endDate: DateTime | Date | string, timezone: string): { startDate: Date, endDate: Date } {

        if (!(startDate && endDate)) {
            return;
        }

        const start = DateUtility.getDateTime(startDate, timezone);
        const end = DateUtility.getDateTime(endDate, timezone);

        const { year, month, day } = DateUtility.getDateTime(originDate, timezone).startOf('day');

        const newStart = start.set({ year, month, day })
        let newEnd = end.set({ year, month, day })
        const diff = newEnd.diff(newStart, 'days').days;
        if (diff < 0) {
            const day = new Decimal(diff).abs().ceil().toNumber();
            const cal = newStart.plus({ days: day });
            newEnd = newEnd.set({ year: cal.year, month: cal.month, day: cal.day });
        }

        return { startDate: newStart.toJSDate(), endDate: newEnd.toJSDate() };
    }
}
